import { Glyph } from "../../types";

const SvgParkingSign: Glyph = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" {...props}>
      <path d="M600-520h60v-80h80q25 0 42.5-17.5T800-660v-40q0-25-17.5-42.5T740-760H600v240Zm60-140v-40h80v40h-80ZM520-400q-33 0-56.5-23.5T440-480v-320q0-33 23.5-56.5T520-880h320q33 0 56.5 23.5T920-800v320q0 33-23.5 56.5T840-400H720v280h-80v-280H520Zm0-80h320v-320H520v320Zm160-160ZM320-120q-17 0-28.5-11.5T280-160v-40H80v-80h240v-200H80v-80h208l-42-120H80v-80h180q19 0 34.5 11t21.5 29l84 240v320q0 17-11.5 28.5T360-120h-40ZM220-320q25 0 42.5-17.5T280-380q0-25-17.5-42.5T220-440q-25 0-42.5 17.5T160-380q0 25 17.5 42.5T220-320Z" />
    </svg>
  );
};

export default SvgParkingSign;
